import React from "react";
import { Alert } from "reactstrap";

const ErrorAlert = ({ error }) => {
  return (
    error && (
      <Alert color="danger">
        <strong>{error}</strong> 
      </Alert>
    )
  );
};

export default ErrorAlert;
